// src/components/ProductsPage/packaging/PackagingFormModal.jsx
import React from "react";
import Button from "../../UI/Button";

export default function PackagingFormModal({
  editing,
  setEditing,
  onSave,
  onClose,
  saving,
}) {
  const handle = (field, value) =>
    setEditing((prev) => ({ ...prev, [field]: value }));

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-start justify-center overflow-y-auto p-4">
      <div className="bg-white rounded-xl p-6 max-w-2xl w-full my-8">
        <div className="flex items-start justify-between mb-4">
          <h3 className="text-xl font-bold">
            {editing.id ? "Редактировать упаковку" : "Новая упаковка"}
          </h3>
          <button
            type="button"
            className="text-gray-500 hover:text-black text-2xl"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1">Название</label>
            <input
              value={editing.name}
              onChange={(e) => handle("name", e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Например: Коробка 10 шт"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Длина (см)</label>
            <input
              type="number"
              step="0.01"
              value={editing.length}
              onChange={(e) => handle("length", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Ширина (см)</label>
            <input
              type="number"
              step="0.01"
              value={editing.width}
              onChange={(e) => handle("width", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Высота (см)</label>
            <input
              type="number"
              step="0.01"
              value={editing.height}
              onChange={(e) => handle("height", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Кол-во товара (шт)</label>
            <input
              type="number"
              step="1"
              min="1"
              value={editing.quantity}
              onChange={(e) => handle("quantity", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Вес нетто (кг)</label>
            <input
              type="number"
              step="0.001"
              value={editing.net_weight}
              onChange={(e) => handle("net_weight", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Вес брутто (кг)</label>
            <input
              type="number"
              step="0.001"
              value={editing.gross_weight}
              onChange={(e) => handle("gross_weight", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Класс упаковки для экосбора
            </label>
            <input
              type="number"
              step="1"
              min="0"
              value={editing.eco_fee_class}
              onChange={(e) => handle("eco_fee_class", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1">Комментарий</label>
            <textarea
              rows={2}
              value={editing.comment || ""}
              onChange={(e) => handle("comment", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Отмена
          </Button>
          <Button variant="primary" onClick={onSave} disabled={saving}>
            {saving ? "Сохранение..." : "Сохранить"}
          </Button>
        </div>
      </div>
    </div>
  );
}